<template>
  <v-app-bar-title
    align="left"
    class="hidden-sm-and-down"
    style="max-width: 380px; min-width: 350px"
  >
    <router-link class="text-decoration-none text-white" to="/">
      <v-row no-gutters class="flex-nowrap">
        <v-avatar size="53" style="background-color: transparent">
          <v-img :src="logo" alt="logo" aspect-ratio="1/1" :cover="false"></v-img>
        </v-avatar>
        <v-col align-self="center" align="left">
            <span v-if="title">{{ title }}</span>
          <span v-else>
              <p class="text-h4 text-white">РОССИЙСКИЙ ХИМИКО</p>
              <p class="text-h4 text-white">ТЕХНОЛОГИЧЕСКИЙ УНИВЕРСИТЕТ</p>
              <p class="text-caption text-white">имени Д.И. Менделеева</p>
            </span>
        </v-col>
      </v-row>
    </router-link>
  </v-app-bar-title>
</template>

<script>
export default {
  name: 'AppBarTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    logo: {
      type: String,
      required: true
    },
  }
}
</script>
